import { render, staticRenderFns } from "./IconSymbol.vue?vue&type=template&id=ecf6beea&scoped=true"
import script from "./IconSymbol.vue?vue&type=script&lang=js"
export * from "./IconSymbol.vue?vue&type=script&lang=js"
import style0 from "./IconSymbol.vue?vue&type=style&index=0&id=ecf6beea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf6beea",
  null
  
)

export default component.exports